import { Button as AntButton, ButtonProps as AntButtonProps } from 'antd';
import styles from './button.module.scss';
import { Size, Variant } from './button.types';
import PopupButtonIcon from '@/assets/icons/chevron-selector-vertical.svg?react';

interface ButtonProps extends AntButtonProps {
  buttonVariant?: Variant;
  buttonSize?: Size;
  rightIcon?: boolean;
}

export function Button({
  buttonVariant = 'primary',
  buttonSize = 'small',
  rightIcon,
  ...props
}: ButtonProps) {
  const { children, icon, className } = props;
  const buttonStatesClass = 'loading' in props ? styles.loadState : styles.pressState;
  const buttonIconClass =
    ('icon' in props && rightIcon) || buttonVariant === 'popup'
      ? styles.rightIconButton
      : styles.leftIconButton;

  const classNames = [
    styles.button,
    styles[buttonVariant],
    styles[buttonSize],
    buttonStatesClass,
    buttonIconClass,
    className,
  ].join(' ');

  return (
    <AntButton
      {...props}
      className={classNames}
      icon={
        buttonVariant === 'popup' ? (
          <PopupButtonIcon stroke={styles.popupIconColor} strokeWidth={2.2} />
        ) : (
          icon
        )
      }
    >
      {children}
    </AntButton>
  );
}
